import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import App from './components/App'
import router from './router'
import store from './store'
import VueTouch from 'vue-touch'
Vue.use(VueTouch, {name: 'v-touch'})

sync(store, router)

let app = new Vue({ router, store, ...App })

export { app, router, store }



// WEBPACK FOOTER //
// ./client/app.js